import React from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { ExternalLink } from "lucide-react";

export const VideoDialog = ({ video, open, onOpenChange }) => {
  if (!video) return null;
  const embedSrc = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
    video.facebook_url
  )}&show_text=false&width=340&height=600&autoplay=true`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="video-dialog"
        className="max-w-[380px] p-0 overflow-hidden bg-[#12495B] border-0"
      >
        <DialogTitle className="sr-only">{video.title}</DialogTitle>
        <div className="w-full bg-black flex justify-center">
          {video.video_url ? (
            <video
              key={video.video_url}
              data-testid="video-player"
              src={`${process.env.REACT_APP_BACKEND_URL}${video.video_url}`}
              className="w-full max-h-[600px]"
              controls
              autoPlay
              playsInline
            />
          ) : (
            <iframe
              key={video.facebook_url}
              data-testid="video-iframe"
              title={video.title}
              src={embedSrc}
              className="w-[340px] h-[600px] border-0"
              style={{ border: "none", overflow: "hidden" }}
              scrolling="no"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              allowFullScreen
            />
          )}
        </div>
        <div className="p-4 text-center">
          <p className="font-display text-lg text-white leading-snug">{video.title}</p>
          {video.subtitle && <p className="text-white/60 text-sm mt-1">{video.subtitle}</p>}
          {!video.video_url && (
          <a
            href={video.facebook_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="video-fallback-link"
            className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-[#F5C518] hover:underline"
          >
            La vidéo ne s'affiche pas ? Ouvrir sur Facebook <ExternalLink size={14} />
          </a>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
